// GA4 measurement ids are "G-" + letters/digits. Sellers paste them by hand (Production
// Settings / event form), so tolerate surrounding whitespace and invisible marks, and reject
// anything else — a malformed value would otherwise be configured and used as `send_to`.
const MEASUREMENT_ID = /^G-[A-Z0-9]+$/
const INVISIBLE = /[\s\u200B-\u200F\u202A-\u202E\uFEFF]/g

export const sanitizeMeasurementId = (raw) => {
    if (typeof raw !== 'string') return null
    const cleaned = raw.replace(INVISIBLE, '').toUpperCase()
    return MEASUREMENT_ID.test(cleaned) ? cleaned : null
}

// gtag sends an event to EVERY measurement id configured on the page unless `send_to` names
// one. A seller page (its GA4) and an event page (possibly another GA4) are visited in one SPA
// session, so each event carries the id of the page it belongs to.
export const withSendTo = (params, measurementId) => {
    const base = { ...(params || {}) }
    return measurementId ? { ...base, send_to: measurementId } : base
}
